import axios from "axios";
// let baseurl = import.meta.env.VITE_BASE_URL;

const AxiosInstance = axios.create({
  // baseURL: baseurl,
  timeout: 250000,
});

export default AxiosInstance;
